<template>
  <div class="verify-machine-wrapper">
    <z-action-picker
      v-model="showPop"
      :title="title"
      :show-btn="true"
      btn-text="我知道了"
      height="60vh"
      @close="onClose"
      @confirm="onConfirm"
    >
      <div
        v-for="(item, index) in qaConfigList"
        :key="index"
        class="item"
      >
        <div class="item-title">{{ item.question }}</div>
        <div class="item-con" v-html="testText"></div>
      </div>
    </z-action-picker>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { ActionPicker } from '@zz-common/zz-ui'
  Vue.use(ActionPicker)
  export default {
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      info: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        showPop: this.show,
        testText: '1, 认证商户使用和平台监测中心相同的演技标准，验机系统；<br /> 2,asjajshajsha',
      }
    },
    mounted() {
      console.log('show>>>>>>>>', this.info)
    },
    watch: {
      show(n) {
        this.showPop = n
      },
    },
    methods: {
      onClose() {
        console.log('onClose>>>>>>>>')
        this.$emit('update:show', false)
      },
      onConfirm() {
        console.log('onConfirm>>>>>>>>')
        this.$emit('update:show', false)
      },
    },
    computed: {
      title() {
        return this.info.report.merchantInspectionExplain?.title|| ' '
      },
      qaConfigList() {
        return this.info.report.merchantInspectionExplain?.qaConfigList || [
        ]
      }
    },
  }
</script>
<style lang="scss">
  .verify-machine-wrapper {
    max-height: 70vh;
    .z-action-picker__title {
      height: 125px;
      font-family: PingFangSC, PingFang SC;

      background: url('https://pic6.zhuanstatic.com/zhuanzh/4362b0da-b899-4bca-af49-1d98925f0d94.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .title-text {
        font-size: 40px;
        font-weight: 500;
        color: #111111;
        position: relative;
        top: -16px;
      }
    }
    .z-action-picker__content {
      position: relative;
      top: -42px;
      padding: 0 24px 0 24px;
      .item {
        width: 686px;
        background: #f8f8f8;
        border-radius: 16px;
        margin: 6px auto;
        padding: 40px 32px;
        box-sizing: border-box;
        .item-title {
          font-size: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #111111;
          line-height: 28px;
        }
        .item-con {
          margin-top: 20px;
          p {
            font-size: 24px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 300;
            color: #666666;
            line-height: 38px;
          }
        }
      }
    }
    .btn {
      width: 702px;
      height: 80px;
      background: #ff483c;
      border-radius: 40px;
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 84px;
      box-sizing: border-box;
    }
  }
</style>
